export enum FruitType {
  Healthy,
  Unhealthy,
}

export enum ResultStatus {
  Win,
  Lose,
}

export type Fruit = {
  id: number;
  name: string;
  type: FruitType;
  left?: number;
  clicked: boolean;
};
